<div class="decline-reason-dialog">
  <!-- Header -->
  <div class="decline-reason-dialog__header">
    <h2 class="decline-reason-dialog__title">{{ 'settings.my_championed.reason_for_declining_title' | translateLang }}</h2>
    <button class="decline-reason-dialog__close-btn" (click)="onClose()" type="button" aria-label="Close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#96080B"/>
        <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Content -->
  <div class="decline-reason-dialog__content">
    <!-- Reason Text -->
    <p class="decline-reason-dialog__reason-text">{{ data.reason }}</p>

    <!-- Declined Info Box -->
    <div class="decline-reason-dialog__info-box">
      <div class="decline-reason-dialog__info-row">
        <span class="decline-reason-dialog__info-label">{{ 'settings.my_championed.declined_by_label' | translateLang }}</span>
        <span class="decline-reason-dialog__info-value">{{ data.declinedBy }}</span>
      </div>
      <div class="decline-reason-dialog__info-row">
        <span class="decline-reason-dialog__info-label">{{ 'settings.my_championed.date_declined_label' | translateLang }}</span>
        <span class="decline-reason-dialog__info-value">{{ data.dateDeclined | date: 'MMMM d, yyyy' }}</span>
      </div>
    </div>
  </div>
</div>
